import React from 'react';
import { Check } from 'lucide-react';
import { YellowButton } from './YellowButton';
import { motion } from 'framer-motion';
interface ComboCardProps {
  title: string;
  price: string;
  originalPrice: string;
  discount: string;
  features: string[];
  description: string;
  isRecommended?: boolean;
  isPremium?: boolean;
  onBuy: () => void;
  image?: string;
}
export function ComboCard({
  title,
  price,
  originalPrice,
  discount,
  features,
  description,
  isRecommended = false,
  isPremium = false,
  onBuy,
  image
}: ComboCardProps) {
  return <motion.div whileHover={{
    y: -5
  }} className={`relative flex flex-col h-full bg-zinc-900 rounded-xl overflow-hidden border ${isRecommended ? 'border-yellow-500 shadow-[0_0_30px_rgba(234,179,8,0.15)] scale-105 z-10' : 'border-zinc-800'}`} data-id="element-272">
      {isRecommended && <div className="absolute top-0 inset-x-0 bg-yellow-500 text-black text-center text-xs font-bold uppercase py-1 tracking-widest z-10" data-id="element-273">
          Más Vendido
        </div>}

      {/* Product Image */}
      {image && <div className={`relative overflow-hidden bg-zinc-950 ${isRecommended ? 'mt-6' : ''}`} data-id="element-274">
          <img src={image} alt={title} className="w-full object-contain object-center" style={{
        height: '240px'
      }} data-id="element-275" />
        </div>}

      <div className={`p-6 flex-1 flex flex-col ${isRecommended ? 'pt-8' : ''}`} data-id="element-276">
        <h3 className={`text-xl font-bold mb-2 ${isRecommended ? 'text-yellow-500' : 'text-white'}`} data-id="element-277">
          {title}
        </h3>
        <p className="text-zinc-400 text-sm mb-6 min-h-[40px]" data-id="element-278">{description}</p>

        <div className="mb-6" data-id="element-279">
          <div className="flex items-center gap-2 mb-1" data-id="element-280">
            <span className="text-zinc-500 line-through text-sm" data-id="element-281">
              {originalPrice}
            </span>
            <span className="bg-red-600 text-white text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-282">
              {discount} OFF
            </span>
          </div>
          <div className="flex items-baseline gap-1" data-id="element-283">
            <span className="text-4xl font-extrabold text-white" data-id="element-284">{price}</span>
            <span className="text-zinc-500 text-sm font-medium" data-id="element-285">
              / único pago
            </span>
          </div>
        </div>

        <ul className="space-y-3 mb-8 flex-1" data-id="element-286">
          {features.map((feature, i) => <li key={i} className="flex items-start gap-3 text-sm text-zinc-300" data-id="element-287">
              <Check className="w-5 h-5 text-yellow-500 flex-shrink-0" data-id="element-288" />
              <span data-id="element-289">{feature}</span>
            </li>)}
        </ul>

        <YellowButton onClick={onBuy} fullWidth variant={isRecommended ? 'primary' : 'outline'} size="lg" data-id="element-290">
          COMPRAR AHORA
        </YellowButton>
      </div>
    </motion.div>;
}